// removed by extract-text-webpack-plugin
module.exports = {"dragableList":"_1nHOtG6_giFK_woXoxbksi","listItem":"FPZE-_ipospeaUDFaH6aG"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/lists/dragable-list.scss
// module id = 98
// module chunks = 0